import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './button.component.scss';
var Button = /** @class */ (function (_super) {
    tslib_1.__extends(Button, _super);
    function Button(element) {
        return _super.call(this, element) || this;
    }
    Button.prototype.init = function () { };
    Button.prototype.bindEvents = function () { };
    return Button;
}(Base));
export { Button };



//////////////////
// WEBPACK FOOTER
// ./components/button/button.component.ts
// module id = 158
// module chunks = 0